import { CartManagerState } from "@/global/store/data/purchaseSeats/cartManager";

export function injectMLBAdobeScript() {
  // prod src
  let scriptSrc = "https://assets.adobedtm.com/267c22ecc15c/514441733727/launch-6d6aa8954ff7.min.js"; // prettier-ignore

  if (process.env.NODE_ENV == "development") {
    // dev src
    scriptSrc = "https://assets.adobedtm.com/267c22ecc15c/514441733727/launch-8d90509f3f0c-development.min.js"; // prettier-ignore
  }

  return new Promise((resolve) => {
    // Check if the script is already loaded
    if (window?.adobeDataLayer) return resolve(true);
    // if not loaded, create a script tag and append it to the head
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.src = scriptSrc;

    script.async = true;
    script.setAttribute("nonce", process?.env?.mlbAdobeScriptNonce || "");
    head?.appendChild(script);
    script.onload = () => resolve(true);
  });
}

export function pushAdobeDataLayer(data: any) {
  try {
    window.adobeDataLayer.push(data);
    console.log(`Adobe data layer event: `, {
      eventData: data,
      adobeDataLayer: window.adobeDataLayer,
    });
  } catch (error) {
    console.error("Error pushing to Adobe data layer: ", error);
  }
}

export function parseCheckoutEventsData(cartManager: CartManagerState) {
  return cartManager.cart.map((cartEvt) => {
    const game_pk = cartEvt.eventCode;

    // total ticket quantity
    const ticket_quantity = cartEvt?.products?.reduce(
      (acc, itm) => acc + (itm.seatCount as number),
      0
    );

    // total ticket price
    const ticket_total_price = cartEvt?.products?.reduce((acc, prd) => {
      if (prd?.totalAllInPrice) {
        return acc + (prd.totalAllInPrice as number);
      }
      return acc + (prd.allInPrice as number) * (prd.seatCount as number);
    }, 0);

    // ticket seat section
    let ticket_seat_section = "";
    if (cartEvt?.products[0]?.sectionName) {
      ticket_seat_section = cartEvt?.products[0]?.sectionName;
    } else if (cartEvt?.products[0]?.sectionNames) {
      ticket_seat_section = cartEvt?.products[0]?.sectionNames?.split(",")[0];
    }

    return {
      game_pk,
      ticket_quantity: String(ticket_quantity),
      ticket_total_price: String(ticket_total_price),
      ticket_seat_section: String(ticket_seat_section),
    };
  });
}
